import React, { useState, useEffect } from 'react';
import useAuthStore from '../store/authStore';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FaPencilAlt, FaStar, FaUser, FaShoppingCart } from 'react-icons/fa';
import ProductCard from '../components/ProductCard';
import ProductCardSkeleton from '../components/ProductCardSkeleton';
import { FaYoutube, FaInstagram } from 'react-icons/fa';
import SEOHead from '../components/SEOHead';
import { apiGet, apiPost, apiPut, apiPatch, getImageUrl } from '../utils/api';
import { useDarkMode } from '../contexts/DarkModeContext';

// function getUser() {
//   return JSON.parse(localStorage.getItem('user')) || {};
// }

export default function ProfilePage() {
  const { username } = useParams();
  const { isDarkMode } = useDarkMode();
  const [tab, setTab] = useState('summary');
  const { user: storeUser, setUser: setAuthUser } = useAuthStore();
  const [seoSettings, setSeoSettings] = useState(null);

  // Fetch SEO settings for profile page
  useEffect(() => {
    const fetchSeoSettings = async () => {
      try {
        const response = await apiGet('/api/page-seo/page/profile');
        if (response.ok) {
          const data = await response.json();
          setSeoSettings(data);
        }
      } catch (error) {
        console.error('Error fetching SEO settings:', error);
      }
    };

    fetchSeoSettings();
  }, []);

  useEffect(() => {
    apiGet('/api/seo?path=/profile')
      .then(res => res.json())
      .then(data => setSeoSettings(data))
      .catch(error => console.error('Error loading SEO settings:', error));
  }, []);

  const isOwner = (!username && storeUser) || (username && storeUser && username === storeUser.username);
  const [user, setUser] = useState(isOwner ? storeUser : {});
  const [cover, setCover] = useState(isOwner ? (storeUser?.cover || 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1400&q=80') : 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1400&q=80');
  // const [coverFile, setCoverFile] = useState(null);
  const defaultAvatar = 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y';
  const [avatar, setAvatar] = useState(isOwner ? (storeUser?.avatar || defaultAvatar) : defaultAvatar);
  // const [avatarFile, setAvatarFile] = useState(null);
  const [hoverAvatar, setHoverAvatar] = useState(false);
  const [hoverCover, setHoverCover] = useState(false);
  const [products, setProducts] = useState([]);
  const [listingStatus, setListingStatus] = useState('active');
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState('');
  const [showEditDesc, setShowEditDesc] = useState(false);
  const [descInput, setDescInput] = useState(user.description || '');
  const [showEditName, setShowEditName] = useState(false);
  const [nameInput, setNameInput] = useState(user.username || '');
  const [savingDescription, setSavingDescription] = useState(false);
  // Demo reviews data
  const demoReviews = [
    {
      user: 'isuru nuwan',
      avatar: 'https://randomuser.me/api/portraits/men/1.jpg',
      spent: 697.75,
      platform: 'YouTube Channels',
      platformIcon: <FaYoutube className="text-red-600" />,
      product: 'Monetize YouTube Channel For Sale followers 1.5k',
      price: 250.0,
      date: '2025-04-26',
      rating: 5,
      text: 'fdgdfg',
    },
    {
      user: 'ambulathsinhala0422',
      avatar: '',
      spent: 665.0,
      platform: 'Instagram Accounts',
      platformIcon: <FaInstagram className="text-pink-500" />,
      product: '7K Followers Insta Account For Sale',
      price: 110.0,
      date: '2025-04-26',
      rating: 5,
      text: 'thank you. highly recommended',
    },
    {
      user: 'demo user 3',
      avatar: 'https://randomuser.me/api/portraits/men/2.jpg',
      spent: 320.0,
      platform: 'YouTube Channels',
      platformIcon: <FaYoutube className="text-red-600" />,
      product: 'Demo YouTube Channel',
      price: 180.0,
      date: '2025-04-25',
      rating: 5,
      text: 'Great service and fast delivery!',
    },
    {
      user: 'demo user 4',
      avatar: '',
      spent: 450.0,
      platform: 'Instagram Accounts',
      platformIcon: <FaInstagram className="text-pink-500" />,
      product: 'Demo Instagram Account',
      price: 99.0,
      date: '2025-04-24',
      rating: 5,
      text: 'Everything went smoothly. Will buy again!',
    },
  ];
  // Demo sales data
  const [sales, setSales] = useState([]);
  const uniqueStatuses = Array.from(new Set(sales.map(s => (s.status || '').toLowerCase()))).filter(Boolean);
  const salesStatuses = [
    { key: 'all', label: 'All' },
    ...uniqueStatuses.map(status => ({
      key: status,
      label: status.charAt(0).toUpperCase() + status.slice(1)
    }))
  ];
  const [salesStatus, setSalesStatus] = useState('all');
  const [purchases, setPurchases] = useState([]);
  const uniquePurchaseStatuses = Array.from(new Set(purchases.map(s => (s.status || '').toLowerCase()))).filter(Boolean);
  const purchaseStatuses = [
    { key: 'all', label: 'All' },
    ...uniquePurchaseStatuses.map(status => ({
      key: status,
      label: status.charAt(0).toUpperCase() + status.slice(1)
    }))
  ];
  const [purchaseStatus, setPurchaseStatus] = useState('all');
  // Demo purchases data and statuses
  // const demoPurchases = Array.from({ length: 9 }).map((_, i) => ({
  //   order: 12000 + i,
  //   date: `2025-05-${19 - Math.floor(i / 3)}`,
  //   productImg: 'https://randomuser.me/api/portraits/women/4.jpg',
  //   product: 'tes12 youtube',
  //   price: 432.00,
  //   status: purchaseStatuses[i % purchaseStatuses.length].key,
  //   statusLabel: purchaseStatuses[i % purchaseStatuses.length].label,
  //   seller: 'sellerA',
  //   country: 'US',
  //   sellerAvatar: '',
  // }));
  const [loadingPurchases, setLoadingPurchases] = useState(false);
  const [errorPurchases, setErrorPurchases] = useState('');
  const [productsFetched, setProductsFetched] = useState(false);
  // Remove demoSales and add real sales state
  const [loadingSales, setLoadingSales] = useState(false);
  const [errorSales, setErrorSales] = useState('');
  // Add state for order modal
  const [orderModal, setOrderModal] = useState(null);
  // Add pagination state at the top of the component
  const [listingsToShow, setListingsToShow] = useState(6);
  const [purchasesToShow, setPurchasesToShow] = useState(6);
  const [salesToShow, setSalesToShow] = useState(6);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [notificationType, setNotificationType] = useState('error');

  // Handle cover image upload
  const handleCoverChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // setCoverFile(file);
      const reader = new FileReader();
      reader.onload = (ev) => {
        setCover(ev.target.result);
        // Save to localStorage and update user
        const updatedUser = { ...user, cover: ev.target.result };
        setUser(updatedUser);
        localStorage.setItem('user', JSON.stringify(updatedUser));
      };
      reader.readAsDataURL(file);
    }
  };

  // Show notification function
  // const showNotificationMessage = (message, type = 'error') => {
  //   setNotificationMessage(message);
  //   setNotificationType(type);
  //   setShowNotification(true);
  //   setTimeout(() => setShowNotification(false), 5000);
  // };

  // Handle avatar image upload
  const handleAvatarChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // setAvatarFile(file);
      const reader = new FileReader();
      reader.onload = async (ev) => {
        setAvatar(ev.target.result);
        // Upload avatar to backend
        try {
          const user = JSON.parse(localStorage.getItem('user'));
          const token = localStorage.getItem('token');
          const response = await fetch('/api/auth/profile', {
            method: 'PATCH',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ id: user.id, avatar: ev.target.result })
          });
          if (!response.ok) throw new Error('Failed to update avatar');
          const updatedUser = await response.json();
          setUser(updatedUser);
          localStorage.setItem('user', JSON.stringify(updatedUser));
        } catch (err) {
          console.error('Error updating avatar:', err);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  // Format registration date
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  };

  // Fetch user's products from backend
  const fetchUserProducts = async () => {
    setLoading(true);
    // setError('');
    try {
      let userId;
      let token = localStorage.getItem('token');
      if (isOwner) {
        userId = storeUser?.id;
      } else {
        userId = user?._id || user?.id;
        token = undefined; // public profile, don't send token
      }
      if (!userId) {
        // setError('User not found');
        setLoading(false);
        return;
      }
      let response;
      if (isOwner) {
        response = await apiGet(`/api/products/user/${userId}`);
      } else {
        response = await apiGet(`/api/products/public/user/${userId}`);
      }
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch products');
      }
      const data = await response.json();
      setProducts(data);
    } catch (err) {
      // setError(err.message || 'Failed to fetch products. Please try again later.');
    } finally {
      setLoading(false);
      setProductsFetched(true);
    }
  };

  // Fetch user's purchases from backend
  const fetchUserPurchases = async () => {
    setLoadingPurchases(true);
    setErrorPurchases('');
    try {
      const response = await apiGet('/api/orders/my');
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch purchases');
      }
      const data = await response.json();
      setPurchases(data);
    } catch (err) {
      setErrorPurchases(err.message || 'Failed to fetch purchases. Please try again later.');
      setPurchases([]);
    } finally {
      setLoadingPurchases(false);
    }
  };

  // Fetch user's sales from backend
  const fetchUserSales = async () => {
    setLoadingSales(true);
    setErrorSales('');
    try {
      const response = await apiGet('/api/orders/sales');
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch sales');
      }
      const data = await response.json();
      setSales(data);
    } catch (err) {
      setErrorSales(err.message || 'Failed to fetch sales. Please try again later.');
      setSales([]);
    } finally {
      setLoadingSales(false);
    }
  };

  // For public view (when viewing someone else's profile)
  useEffect(() => {
    if (username && (!storeUser || username !== storeUser.username)) {
      setLoading(true);
      apiGet(`/api/users/public/${username}`)
        .then(res => {
          if (!res.ok) throw new Error('User not found');
          return res.json();
        })
        .then(data => {
          // Only update if user is different
          if (!user || user._id !== data._id) {
            setUser(data);
            setAvatar(data.avatar || defaultAvatar);
            setCover(data.cover || 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1400&q=80');
          }
          setLoading(false);
        })
        .catch(err => {
          // setError(err.message);
          setLoading(false);
        });
    }
  }, [username]);

  // For owner view (when viewing your own profile)
  useEffect(() => {
    if ((!username || (storeUser && username === storeUser.username)) && storeUser) {
      // Fetch latest user data to ensure banned status is up-to-date
              apiGet(`/api/users/public/${storeUser.username}`)
        .then(res => {
          if (!res.ok) throw new Error('User not found');
          return res.json();
        })
        .then(data => {
          // Only update if user is different or if banned status changed
          if (!user || user.id !== data._id || user.isBanned !== data.isBanned) {
            setUser(data);
            setAvatar(data.avatar || defaultAvatar);
            setCover(data.cover || 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1400&q=80');
          }
        })
        .catch(err => {
          console.error('Error fetching user data:', err);
          // Fallback to storeUser if API fails
          if (!user || user.id !== storeUser.id) {
            setUser(storeUser);
            setAvatar(storeUser?.avatar || defaultAvatar);
            setCover(storeUser?.cover || 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1400&q=80');
          }
        });
    }
  }, [storeUser, username]);

  const userId = isOwner ? storeUser?.id : user?._id || user?.id;
  useEffect(() => {
    if (userId && (tab === 'listings' || tab === 'summary')) {
      fetchUserProducts();
    }
  }, [userId, tab]);

  useEffect(() => {
    if (tab === 'purchases') {
      fetchUserPurchases();
    }
    // eslint-disable-next-line
  }, [tab]);

  // Fetch sales when My Sales tab is active
  useEffect(() => {
    if (tab === 'sales') {
      fetchUserSales();
    }
    // eslint-disable-next-line
  }, [tab]);

  return (
    <>
      <SEOHead
        title={seoSettings?.title || 'Profile - YTProud'}
        description={seoSettings?.description || 'Manage your YTProud profile, view orders, and account settings.'}
        keywords={seoSettings?.keywords || 'profile, account settings, user profile'}
        ogTitle={seoSettings?.ogTitle || 'Profile - YTProud'}
        ogDescription={seoSettings?.ogDescription || 'Manage your profile and settings'}
        ogImage={seoSettings?.ogImage || '/images/profile-og.jpg'}
        schemaEnabled={seoSettings?.schemaEnabled || false}
        schemaJsonLd={seoSettings?.customSchemaJsonLd}
      />
      <Header />
      
      {/* Modern Notification */}
      {showNotification && (
        <div className={`fixed top-4 right-4 z-50 max-w-sm w-full bg-white rounded-lg shadow-lg border-l-4 ${
          notificationType === 'error' ? 'border-red-500' : 'border-green-500'
        } p-4 transform transition-all duration-300 ease-in-out`}>
          <div className="flex items-start">
            <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center ${
              notificationType === 'error' ? 'bg-red-100' : 'bg-green-100'
            }`}>
              {notificationType === 'error' ? (
                <svg className="w-4 h-4 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              ) : (
                <svg className="w-4 h-4 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              )}
            </div>
            <div className="ml-3 w-0 flex-1">
              <p className={`text-sm font-medium ${
                notificationType === 'error' ? 'text-red-800' : 'text-green-800'
              }`}>
                {notificationMessage}
              </p>
            </div>
            <div className="ml-4 flex-shrink-0 flex">
              <button
                onClick={() => setShowNotification(false)}
                className={`inline-flex text-gray-400 hover:text-gray-600 focus:outline-none focus:text-gray-600 transition ease-in-out duration-150`}
              >
                <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={`min-h-screen flex flex-col items-center py-4 sm:py-6 md:py-8 px-4 sm:px-6 transition-colors duration-300 ${
        isDarkMode ? 'bg-[#0f0f0f]' : 'bg-gray-50'
      }`}>
        <div className={`w-full max-w-[1650px] mx-auto rounded-xl sm:rounded-2xl shadow-lg sm:shadow-2xl overflow-hidden transition-all duration-500 ${
          isDarkMode 
            ? 'bg-[#2a2a2a] shadow-2xl shadow-black/50 border border-gray-700/50' 
            : 'bg-white'
        }`}>
          {/* Cover Art Banner */}
          <div className="w-full h-[140px] sm:h-[160px] md:h-[180px] lg:h-[220px] bg-gray-200 relative"
            onMouseEnter={() => isOwner && !user.isBanned && setHoverCover(true)}
            onMouseLeave={() => isOwner && !user.isBanned && setHoverCover(false)}
          >
            <img src={cover} alt="Cover" className="w-full h-full object-cover rounded-t-2xl" />
            {/* Camera/upload icon */}
            {isOwner && !user.isBanned && (
              <label className={`absolute top-2 sm:top-4 right-2 sm:right-4 bg-black bg-opacity-70 text-white text-xs px-2 py-1 rounded flex items-center gap-1 cursor-pointer hover:bg-opacity-90 transition z-10 ${hoverCover ? '' : 'opacity-0 pointer-events-none'}`}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 sm:w-5 sm:h-5"><path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5V7.5A2.25 2.25 0 015.25 5.25h2.086a2.25 2.25 0 001.591-.659l.828-.828A2.25 2.25 0 0111.75 3h.5a2.25 2.25 0 011.595.663l.828.828a2.25 2.25 0 001.591.659h2.086A2.25 2.25 0 0121 7.5v9a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 16.5z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" /></svg>
                <span className="hidden sm:inline">Change Cover</span>
                <input type="file" accept="image/*" className="hidden" onChange={handleCoverChange} />
              </label>
            )}
            <span className="absolute bottom-2 right-2 sm:right-4 bg-black bg-opacity-70 text-white text-xs px-2 py-1 rounded hidden sm:block">Recommended: 1400x180px</span>
          </div>
          {/* Main Content Row */}
          <div className="flex flex-col lg:flex-row">
            {/* Left Profile Card */}
            <div className={`w-full lg:w-[400px] p-4 sm:p-6 flex flex-col items-center relative border-b lg:border-b-0 lg:border-r pt-0 transition-colors duration-300 ${
              isDarkMode ? 'border-gray-700' : 'border-gray-100'
            }`}>
              {/* Avatar - overlap cover */}
              <div className="relative z-10 -mt-12 sm:-mt-16 mb-2 flex flex-col items-center"
                onMouseEnter={() => isOwner && !user.isBanned && setHoverAvatar(true)}
                onMouseLeave={() => isOwner && !user.isBanned && setHoverAvatar(false)}
              >
                <img src={avatar} alt="Avatar" className="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] rounded-full border-4 border-white shadow-lg object-cover" />
                {/* Camera icon for avatar */}
                {isOwner && !user.isBanned && (
                  <label className={`absolute bottom-1 sm:bottom-2 right-1 sm:right-2 bg-black bg-opacity-70 text-white p-1 rounded-full cursor-pointer transition ${hoverAvatar ? '' : 'opacity-0 pointer-events-none'}`} title="Change Profile Picture">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 sm:w-5 sm:h-5"><path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5V7.5A2.25 2.25 0 015.25 5.25h2.086a2.25 2.25 0 001.591-.659l.828-.828A2.25 2.25 0 0111.75 3h.5a2.25 2.25 0 011.595.663l.828.828a2.25 2.25 0 001.591.659h2.086A2.25 2.25 0 0121 7.5v9a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 16.5z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" /></svg>
                    <input type="file" accept="image/*" className="hidden" onChange={handleAvatarChange} />
                  </label>
                )}
                {isOwner && <span className="absolute bottom-1 sm:bottom-2 left-1 sm:left-2 w-4 h-4 sm:w-5 sm:h-5 bg-green-500 border-2 border-white rounded-full"></span>}
              </div>
              <h3 className={`text-xl sm:text-2xl font-bold flex items-center gap-2 text-center transition-colors duration-300 ${
                isDarkMode ? 'text-white' : 'text-black'
              }`}>
                {user.username || 'User'}
                {user.isBanned && (
                  <span className="text-red-600 font-bold">(banned)</span>
                )}
                {isOwner && !user.isBanned && (
                  <button onClick={() => setShowEditName(true)} className="ml-2 text-gray-500 hover:text-red-600" title="Edit Name">
                    <FaPencilAlt className="w-4 h-4 sm:w-5 sm:h-5" />
                  </button>
                )}
                {user.verified && <span title="Verified"><svg width="18" height="18" className="sm:w-[22px] sm:h-[22px] inline" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="12" fill="#2563eb"/><path d="M7 13l3 3 7-7" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></span>}
              </h3>
              <div className={`font-semibold mb-2 text-center transition-colors duration-300 ${
                isDarkMode ? 'text-gray-300' : 'text-gray-500'
              }`}>Account details</div>
              <div className={`text-base sm:text-lg font-bold mb-1 text-center transition-colors duration-300 ${
                isDarkMode ? 'text-white' : 'text-black'
              }`}>
                {user.transactions || 0}
                <span className={`font-normal transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-500'
                }`}> Transactions totaling </span>
                <span className="text-base sm:text-lg font-bold">
                  ${user.totalAmount ? user.totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 }) : '0.00'}
                </span>
              </div>
              <div className={`mb-2 text-center text-sm sm:text-base transition-colors duration-300 ${
                isDarkMode ? 'text-gray-300' : 'text-gray-500'
              }`}>Member since: <span className={`font-bold transition-colors duration-300 ${
                isDarkMode ? 'text-white' : 'text-black'
              }`}>{formatDate(user.createdAt)}</span></div>
              <div className={`rounded-xl shadow p-3 sm:p-4 w-full text-center mt-2 transition-all duration-500 ${
                isDarkMode 
                  ? 'bg-gradient-to-br from-[#2a2a2a] via-[#1a1a1a] to-[#2a2a2a] border border-gray-700/50 shadow-lg shadow-black/30' 
                  : 'bg-white'
              }`}>
                <div className={`text-base sm:text-lg font-semibold mb-1 transition-colors duration-300 ${
                  isDarkMode ? 'text-white' : 'text-black'
                }`}>Ratings</div>
                <div className="flex items-center justify-center gap-2 mb-1">
                  <span className="text-xl sm:text-2xl font-bold text-red-600">{user.rating ? user.rating.toFixed(1) : '5.0'}</span>
                  <span className="text-red-500 text-lg sm:text-xl">{'★'.repeat(Math.round(user.rating || 5))}{'☆'.repeat(5 - Math.round(user.rating || 5))}</span>
                </div>
                <div className={`text-xs sm:text-sm transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-400' : 'text-gray-500'
                }`}>Based on <span className="text-red-600 font-bold underline cursor-pointer">{user.reviews || 0} review{(user.reviews || 0) !== 1 ? 's' : ''}</span></div>
              </div>
              {/* Edit Name Modal */}
              {isOwner && showEditName && (
                <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-40 p-4">
                  <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 md:p-8 w-full max-w-xl relative">
                    <h2 className="text-xl sm:text-2xl font-bold mb-4 flex items-center gap-2">
                      <span className="inline-block"><FaPencilAlt className="w-5 h-5" /></span> Edit Profile Name
                    </h2>
                    <input
                      className="w-full border rounded p-3 mb-4 text-base"
                      value={nameInput}
                      onChange={e => setNameInput(e.target.value)}
                      placeholder="Enter your profile name..."
                    />
                    <div className="flex flex-col sm:flex-row justify-end gap-2">
                      <button className="px-4 py-2 rounded bg-gray-200 text-gray-700 text-sm sm:text-base" onClick={() => setShowEditName(false)}>Cancel</button>
                      <button
                        className="px-4 py-2 rounded bg-red-600 text-white font-semibold hover:bg-red-700 transition text-sm sm:text-base"
                        onClick={async () => {
                          try {
                            const response = await apiPatch('/api/auth/profile', { username: nameInput });
                            if (!response.ok) throw new Error('Failed to update username');
                            const updatedUser = await response.json();
                            setUser(updatedUser);
                            setAuthUser(updatedUser); // Update auth store
                            localStorage.setItem('user', JSON.stringify(updatedUser));
                            setShowEditName(false);
                          } catch (err) {
                            alert('Failed to update username');
                          }
                        }}
                      >Save</button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* Right Dashboard */}
            <div className="flex-1 p-4 sm:p-6 md:p-8 min-w-0">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
                <div className={`text-xl sm:text-2xl font-bold transition-colors duration-300 ${
                  isDarkMode ? 'text-white' : 'text-gray-900'
                }`}>
                  Hello, {user.username || 'User'}! <span className="text-lg sm:text-xl">✌️</span>
                  {user.isBanned && (
                    <span className="text-red-600 font-bold">(banned)</span>
                  )}
                </div>
                {isOwner && !user.isBanned && (
                  <div className="flex flex-col sm:flex-row gap-2">
                    <button className="px-3 sm:px-4 py-2 rounded border border-gray-300 bg-white text-gray-700 font-semibold hover:bg-gray-100 transition text-sm sm:text-base">See Public View</button>
                    <button className="px-3 sm:px-4 py-2 rounded bg-red-600 text-white font-semibold hover:bg-red-700 transition text-sm sm:text-base">Profile Settings</button>
                  </div>
                )}
              </div>
              {/* Tabs */}
              <div className={`flex flex-wrap gap-4 sm:gap-6 md:gap-8 border-b mb-6 sm:mb-8 text-base sm:text-lg font-semibold overflow-x-auto transition-colors duration-300 ${
                isDarkMode ? 'border-gray-700' : 'border-gray-200'
              }`}>
                <button className={tab === 'summary' ? (isDarkMode ? 'text-blue-400 border-b-2 border-blue-400 pb-2' : 'text-red-600 border-b-2 border-red-600 pb-2') : isDarkMode ? 'text-gray-300 pb-2 hover:text-white' : 'text-gray-600 pb-2'} onClick={() => setTab('summary')}>Summary</button>
                <button className={tab === 'listings' ? (isDarkMode ? 'text-blue-400 border-b-2 border-blue-400 pb-2' : 'text-red-600 border-b-2 border-red-600 pb-2') : isDarkMode ? 'text-gray-300 pb-2 hover:text-white' : 'text-gray-600 pb-2'} onClick={() => setTab('listings')}>My Listings</button>
                <button className={tab === 'reviews' ? (isDarkMode ? 'text-blue-400 border-b-2 border-blue-400 pb-2' : 'text-red-600 border-b-2 border-red-600 pb-2') : isDarkMode ? 'text-gray-300 pb-2 hover:text-white' : 'text-gray-600 pb-2'} onClick={() => setTab('reviews')}>Reviews</button>
                {isOwner && <button className={tab === 'sales' ? (isDarkMode ? 'text-blue-400 border-b-2 border-blue-400 pb-2' : 'text-red-600 border-b-2 border-red-600 pb-2') : isDarkMode ? 'text-gray-300 pb-2 hover:text-white' : 'text-gray-600 pb-2'} onClick={() => setTab('sales')}>My Sales</button>}
                {isOwner && <button className={tab === 'purchases' ? (isDarkMode ? 'text-blue-400 border-b-2 border-blue-400 pb-2' : 'text-red-600 border-b-2 border-red-600 pb-2') : isDarkMode ? 'text-gray-300 pb-2 hover:text-white' : 'text-gray-600 pb-2'} onClick={() => setTab('purchases')}>My Purchases</button>}
              </div>
              {/* Banned User Message */}
              {isOwner && user.isBanned && (
                <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <div className="ml-3">
                      <h3 className="text-sm font-medium text-red-800">
                        Account Suspended
                      </h3>
                      <div className="mt-2 text-sm text-red-700">
                        <p>Your account has been suspended. You cannot:</p>
                        <ul className="list-disc list-inside mt-1 space-y-1">
                          <li>Edit your profile information</li>
                          <li>Change your profile or cover images</li>
                          <li>Make new purchases</li>
                        </ul>
                        {user.banReason && (
                          <p className="mt-2 font-medium">Reason: {user.banReason}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Tab Content */}
              {tab === 'summary' && (
                <div>
                  <div className="mb-8">
                    <div className="flex items-center gap-2 sm:gap-3 mb-2 text-lg sm:text-xl font-bold">
                      <FaUser className="w-5 h-5 sm:w-6 sm:h-6 text-red-600" />
                      Profile Description
                      {isOwner && !user.isBanned && (
                        <button onClick={() => setShowEditDesc(true)} className="ml-2 text-gray-500 hover:text-red-600" title="Edit Description">
                          <FaPencilAlt className="w-4 h-4 sm:w-5 sm:h-5" />
                        </button>
                      )}
                    </div>
                    <div className={`text-base sm:text-lg mb-4 sm:mb-6 transition-colors duration-300 ${
                      isDarkMode ? 'text-white' : 'text-gray-700'
                    }`}>
                      {user.isBanned ? (
                        <div className="text-red-600 font-semibold">
                          This account has been suspended by our administrators.
                          {user.banReason && (
                            <div className={`text-sm mt-1 transition-colors duration-300 ${
                              isDarkMode ? 'text-gray-400' : 'text-gray-600'
                            }`}>
                              Reason: {user.banReason}
                            </div>
                          )}
                        </div>
                      ) : (
                        user.description || 'Welcome!'
                      )}
                    </div>
                    {/* Edit Description Modal */}
                    {isOwner && showEditDesc && (
                      <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-40 p-4">
                        <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6 md:p-8 w-full max-w-xl relative">
                          <h2 className="text-xl sm:text-2xl font-bold mb-4 flex items-center gap-2">
                            <span className="inline-block"><FaPencilAlt className="w-5 h-5" /></span> Edit Profile Description
                          </h2>
                          <textarea
                            className="w-full border rounded p-3 mb-4 min-h-[120px] text-base"
                            value={descInput}
                            onChange={e => setDescInput(e.target.value)}
                            placeholder="Enter your profile description..."
                          />
                          <div className="flex flex-col sm:flex-row justify-end gap-2">
                            <button className="px-4 py-2 rounded bg-gray-200 text-gray-700 text-sm sm:text-base" onClick={() => setShowEditDesc(false)}>Cancel</button>
                            <button
                              className="px-4 py-2 rounded bg-red-600 text-white font-semibold hover:bg-red-700 transition disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base"
                              disabled={savingDescription}
                              onClick={async () => {
                                setSavingDescription(true);
                                try {
                                  const response = await apiPatch('/api/auth/profile', { description: descInput });
                                  if (!response.ok) throw new Error('Failed to update description');
                                  const updatedUser = await response.json();
                                  setUser(updatedUser);
                                  setAuthUser(updatedUser); // Update auth store
                                  localStorage.setItem('user', JSON.stringify(updatedUser));
                                  setShowEditDesc(false);
                                } catch (err) {
                                  alert('Failed to update description');
                                } finally {
                                  setSavingDescription(false);
                                }
                              }}
                            >
                              {savingDescription ? (
                                <span className="flex items-center justify-center">
                                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                  </svg>
                                  Saving...
                                </span>
                              ) : (
                                'Save'
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* Featured Listings Section */}
                  <div className="mb-6 sm:mb-8">
                    <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6 text-lg sm:text-xl font-bold">
                      <FaShoppingCart className="w-5 h-5 sm:w-6 sm:h-6 text-red-600" />
                      Featured Listings
                    </div>
                    {!productsFetched ? (
                      <div className="w-full">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 sm:gap-3 lg:gap-6">
                          {[...Array(4)].map((_, idx) => (
                            <ProductCardSkeleton key={idx} />
                          ))}
                        </div>
                      </div>
                    ) : products.filter(p => p.status === 'published').length > 0 ? (
                      <div className="w-full">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 sm:gap-3 lg:gap-6">
                          {products.filter(p => p.status === 'published').slice(-4).reverse().map((item, idx) => (
                            <ProductCard key={item._id || idx} product={item} featured={true} />
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div className="flex flex-col items-center justify-center py-8 sm:py-16 bg-white rounded-xl shadow-none border-none mx-auto max-w-lg mt-4 sm:mt-8">
                        {/* Shopping bags SVG icon */}
                        <svg width="60" height="60" className="sm:w-[80px] sm:h-[80px] mb-4" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="14" y="20" width="24" height="28" rx="3" fill="#F87171" stroke="#111" strokeWidth="2"/>
                          <rect x="28" y="28" width="18" height="20" rx="2.5" fill="#FBBF24" stroke="#111" strokeWidth="2"/>
                          <path d="M20 20V16a8 8 0 0116 0v4" stroke="#111" strokeWidth="2"/>
                          <circle cx="22" cy="32" r="2" fill="#fff" stroke="#111" strokeWidth="1.5"/>
                          <circle cx="34" cy="32" r="2" fill="#fff" stroke="#111" strokeWidth="1.5"/>
                        </svg>
                        <div className="text-lg sm:text-xl font-bold text-gray-900 mb-1 text-center">
                          No active or sold listings to display.
                        </div>
                        <div className="text-gray-500 text-sm sm:text-base text-center">
                          Product listings will be displayed here when available.
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {tab === 'listings' && (
                <div>
                  <div className="mb-8">
                    <div className="mb-4 sm:mb-6">
                      <div className={`inline-flex flex-wrap gap-2 sm:gap-3 rounded-xl px-3 sm:px-4 py-2 items-center shadow-sm transition-all duration-300 ${
                        isDarkMode 
                          ? 'bg-gradient-to-br from-[#2a2a2a] via-[#1a1a1a] to-[#2a2a2a] border border-gray-700/50 shadow-lg shadow-black/30' 
                          : 'bg-white border border-gray-200'
                      }`}>
                        <button
                          className={`px-4 sm:px-6 py-2.5 rounded-lg font-semibold text-sm sm:text-base transition-all duration-200 ${
                            listingStatus === 'active' 
                              ? 'bg-red-600 text-white shadow-md' 
                              : isDarkMode 
                                ? 'bg-gray-700 text-gray-200 hover:bg-gray-600 border border-gray-600' 
                                : 'bg-gray-50 text-gray-700 hover:bg-gray-100 border border-gray-200'
                          }`}
                          onClick={() => setListingStatus('active')}
                        >
                          Active ({products.filter(p => (isOwner && (p.status === 'published' || p.status === 'active') && p.status !== 'sold' && p.stockStatus !== 'outofstock') || (!isOwner && p.status === 'published' && p.status !== 'sold' && p.stockStatus !== 'outofstock')).length})
                        </button>
                        {isOwner && (
                          <button
                            className={`px-4 sm:px-6 py-2.5 rounded-lg font-semibold text-sm sm:text-base transition-all duration-200 ${
                              listingStatus === 'pending' 
                                ? 'bg-red-600 text-white shadow-md' 
                                : isDarkMode 
                                  ? 'bg-gray-700 text-gray-200 hover:bg-gray-600 border border-gray-600' 
                                  : 'bg-gray-50 text-gray-700 hover:bg-gray-100 border border-gray-200'
                            }`}
                            onClick={() => setListingStatus('pending')}
                          >
                            Pending ({products.filter(p => p.status === 'pending').length})
                          </button>
                        )}
                        {isOwner && (
                          <button
                            className={`px-4 sm:px-6 py-2.5 rounded-lg font-semibold text-sm sm:text-base transition-all duration-200 ${
                              listingStatus === 'reject' 
                                ? 'bg-red-600 text-white shadow-md' 
                                : isDarkMode 
                                  ? 'bg-gray-700 text-gray-200 hover:bg-gray-600 border border-gray-600' 
                                  : 'bg-gray-50 text-gray-700 hover:bg-gray-100 border border-gray-200'
                            }`}
                            onClick={() => setListingStatus('reject')}
                          >
                            Reject ({products.filter(p => p.status === 'reject' || p.status === 'rejected' || p.status === 'riject').length})
                          </button>
                        )}
                        <button
                          className={`px-4 sm:px-6 py-2.5 rounded-lg font-semibold text-sm sm:text-base transition-all duration-200 ${
                            listingStatus === 'sold' 
                              ? 'bg-red-600 text-white shadow-md' 
                              : isDarkMode 
                                ? 'bg-gray-700 text-gray-200 hover:bg-gray-600 border border-gray-600' 
                                : 'bg-gray-50 text-gray-700 hover:bg-gray-100 border border-gray-200'
                          }`}
                          onClick={() => setListingStatus('sold')}
                        >
                          Sold ({products.filter(p => p.status === 'sold' || p.stockStatus === 'outofstock').length})
                        </button>
                      </div>
                    </div>
                    {loading ? (
                      <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">
                        {[...Array(6)].map((_, idx) => (
                          <ProductCardSkeleton key={idx} />
                        ))}
                      </div>
                    ) : !loading && (
                      products.length === 0 ||
                      (listingStatus === 'active' && products.filter(p => (isOwner ? (['published', 'active'].includes(p.status) && p.status !== 'sold' && p.stockStatus !== 'outofstock') : (p.status === 'published' && p.status !== 'sold' && p.stockStatus !== 'outofstock'))).length === 0) ||
                      (listingStatus === 'pending' && products.filter(p => (p.status === 'pending' || p.status === 'pendings')).length === 0) ||
                      (listingStatus === 'reject' && products.filter(p => (p.status === 'reject' || p.status === 'rejected' || p.status === 'riject')).length === 0) ||
                      (listingStatus === 'sold' && products.filter(p => (isOwner ? (p.status === 'sold' || p.stockStatus === 'outofstock') : (p.status === 'sold' || p.stockStatus === 'outofstock'))).length === 0)
                    ) ? (
                      <div className="flex flex-col items-center justify-center py-16 bg-white rounded-xl shadow-none border-none mx-auto max-w-lg mt-8">
                        {/* Shopping bags SVG icon */}
                        <svg width="80" height="80" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-4">
                          <rect x="14" y="20" width="24" height="28" rx="3" fill="#F87171" stroke="#111" strokeWidth="2"/>
                          <rect x="28" y="28" width="18" height="20" rx="2.5" fill="#FBBF24" stroke="#111" strokeWidth="2"/>
                          <path d="M20 20V16a8 8 0 0116 0v4" stroke="#111" strokeWidth="2"/>
                          <circle cx="22" cy="32" r="2" fill="#fff" stroke="#111" strokeWidth="1.5"/>
                          <circle cx="34" cy="32" r="2" fill="#fff" stroke="#111" strokeWidth="1.5"/>
                        </svg>
                        <div className="text-xl font-bold text-gray-900 mb-1 text-center">
                          {listingStatus === 'active' && 'No active listings to display.'}
                          {listingStatus === 'pending' && 'No pending listings to display.'}
                          {listingStatus === 'reject' && 'No rejected listings to display.'}
                          {listingStatus === 'sold' && 'No sold listings to display.'}
                        </div>
                        <div className="text-gray-500 text-base text-center">
                          Product listings will be displayed here when available.
                        </div>
                      </div>
                    ) : (
                      <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">
                        {products.filter(p =>
                          (listingStatus === 'active' && ((isOwner && (p.status === 'published' || p.status === 'active') && p.status !== 'sold' && p.stockStatus !== 'outofstock') || (!isOwner && p.status === 'published' && p.status !== 'sold' && p.stockStatus !== 'outofstock')))
                          || (listingStatus === 'pending' && (p.status === 'pending' || p.status === 'pendings'))
                          || (listingStatus === 'reject' && (p.status === 'reject' || p.status === 'rejected' || p.status === 'riject'))
                          || (listingStatus === 'sold' && ((isOwner && (p.status === 'sold' || p.stockStatus === 'outofstock')) || (!isOwner && (p.status === 'sold' || p.stockStatus === 'outofstock'))))
                        ).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // Sort by latest upload first
                        .slice(0, listingsToShow).map((product, idx) => (
                          <ProductCard key={product._id || idx} product={product} />
                        ))}
                      </div>
                    )}
                    {(!loading && products.filter(p =>
                      (listingStatus === 'active' && ((isOwner && (p.status === 'published' || p.status === 'active') && p.status !== 'sold' && p.stockStatus !== 'outofstock') || (!isOwner && p.status === 'published' && p.status !== 'sold' && p.stockStatus !== 'outofstock')))
                      || (listingStatus === 'pending' && (p.status === 'pending' || p.status === 'pendings'))
                      || (listingStatus === 'reject' && (p.status === 'reject' || p.status === 'rejected' || p.status === 'riject'))
                      || (listingStatus === 'sold' && ((isOwner && (p.status === 'sold' || p.stockStatus === 'outofstock')) || (!isOwner && (p.status === 'sold' || p.stockStatus === 'outofstock'))))
                    ).length > listingsToShow) && (
                      <div className="flex justify-center mt-4 sm:mt-6">
                        <button
                          className="px-4 sm:px-6 py-2 rounded-full bg-red-600 text-white font-semibold hover:bg-red-700 transition text-sm sm:text-base"
                          onClick={() => setListingsToShow(listingsToShow + 6)}
                        >
                          Load More
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {tab === 'reviews' && (
                <div>
                  <div className="mb-6 sm:mb-8">
                    <div className="text-xl sm:text-2xl font-bold mb-4">Reviews</div>
                    {/* Review Summary Card */}
                    <div className={`rounded-2xl shadow p-4 sm:p-6 md:p-8 flex flex-col md:flex-row items-center md:items-start gap-4 sm:gap-6 md:gap-8 mb-6 sm:mb-8 transition-all duration-500 ${
                      isDarkMode 
                        ? 'bg-[#2a2a2a] shadow-2xl shadow-black/50 border border-gray-700/50' 
                        : 'bg-white'
                    }`}>
                                              <div className="flex flex-col items-center justify-center w-full md:w-1/4">
                        <div className={`text-4xl sm:text-5xl font-bold mb-2 transition-colors duration-300 ${
                          isDarkMode ? 'text-white' : 'text-gray-900'
                        }`}>5.0</div>
                          <div className="flex gap-1 mb-2">
                            {[...Array(5)].map((_, i) => <FaStar key={i} className="text-red-500 text-lg sm:text-xl" />)}
                          </div>
                        <div className={`text-xs sm:text-sm transition-colors duration-300 ${
                          isDarkMode ? 'text-gray-400' : 'text-gray-500'
                        }`}>based on 4 reviews</div>
                        </div>
                      <div className="flex-1 w-full">
                        {[5,4,3,2,1].map(star => (
                          <div key={star} className="flex items-center gap-2 mb-1">
                            <span className={`text-sm w-6 transition-colors duration-300 ${
                              isDarkMode ? 'text-gray-400' : 'text-gray-500'
                            }`}>{star} <FaStar className={`inline text-xs transition-colors duration-300 ${
                              isDarkMode ? 'text-gray-500' : 'text-gray-400'
                            }`} /></span>
                            <div className={`flex-1 h-2 rounded overflow-hidden transition-colors duration-300 ${
                              isDarkMode ? 'bg-gray-700' : 'bg-gray-100'
                            }`}>
                              <div className={`h-2 rounded bg-red-500`} style={{width: star === 5 ? '100%' : '0%'}}></div>
                            </div>
                            <span className={`text-sm w-4 text-right transition-colors duration-300 ${
                              isDarkMode ? 'text-gray-400' : 'text-gray-500'
                            }`}>{star === 5 ? 4 : 0}</span>
                          </div>
                        ))}
                                </div>
                              </div>
                    {/* Review Cards */}
                    {demoReviews.map((r, idx) => (
                      <div key={idx} className={`rounded-2xl shadow p-4 sm:p-6 mb-4 sm:mb-6 flex flex-col gap-2 transition-all duration-500 ${
                        isDarkMode 
                          ? 'bg-[#2a2a2a] shadow-2xl shadow-black/50 border border-gray-700/50' 
                          : 'bg-white'
                      }`}>
                        <div className="flex items-center justify-between mb-2">
                          <div className="flex items-center gap-3">
                            {r.avatar ? (
                              <img src={r.avatar} alt={r.user} className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full object-cover border-2 transition-colors duration-300 ${
                                isDarkMode ? 'border-gray-600' : 'border-gray-200'
                              }`} />
                            ) : (
                              <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center text-xl sm:text-2xl font-bold transition-colors duration-300 ${
                                isDarkMode ? 'bg-gray-700 text-gray-400' : 'bg-gray-200 text-gray-500'
                              }`}>
                                <span>{r.user[0].toUpperCase()}</span>
                              </div>
                            )}
                            <div>
                              <div className={`font-bold text-base sm:text-lg transition-colors duration-300 ${
                                isDarkMode ? 'text-white' : 'text-gray-900'
                              }`}>{r.user}</div>
                              <div className={`text-xs sm:text-sm transition-colors duration-300 ${
                                isDarkMode ? 'text-gray-400' : 'text-gray-500'
                              }`}>Total spent: <span className="font-semibold text-red-600">${r.spent.toFixed(2)}</span></div>
                            </div>
                          </div>
                          <div className="flex flex-col items-end">
                            <div className="flex gap-1 mb-1">
                              {[...Array(r.rating)].map((_, i) => <FaStar key={i} className="text-red-500 text-base sm:text-lg" />)}
                            </div>
                            <div className={`text-xs sm:text-sm transition-colors duration-300 ${
                              isDarkMode ? 'text-gray-400' : 'text-gray-500'
                            }`}>{new Date(r.date).toLocaleDateString('en-GB')}</div>
                          </div>
                        </div>
                        <div className="flex items-center gap-2 mb-1 flex-wrap">
                          {r.platformIcon}
                          <span className={`text-sm sm:text-base font-semibold transition-colors duration-300 ${
                            isDarkMode ? 'text-gray-300' : 'text-gray-700'
                          }`}>{r.platform}</span>
                          <span className={`font-semibold text-sm sm:text-base transition-colors duration-300 ${
                            isDarkMode ? 'text-gray-300' : 'text-gray-700'
                          }`}>{r.product}</span>
                          <span className="text-blue-700 font-bold ml-2 text-sm sm:text-base">${r.price.toFixed(2)}</span>
                        </div>
                        <div className={`text-sm sm:text-base mt-2 transition-colors duration-300 ${
                          isDarkMode ? 'text-gray-300' : 'text-gray-700'
                        }`}>{r.text}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {tab === 'sales' && (
                <div>
                  <div className="mb-8">
                    <div className="text-2xl font-bold mb-4">My Sales (Total Items Sold: {sales.length})</div>
                    {/* Status Filter Bar */}
                    <div className="mb-8">
                      <div className={`inline-flex flex-wrap gap-2 sm:gap-3 rounded-xl px-3 sm:px-4 py-2 items-center shadow-sm transition-all duration-300 ${
                        isDarkMode 
                          ? 'bg-gradient-to-br from-[#2a2a2a] via-[#1a1a1a] to-[#2a2a2a] border border-gray-700/50 shadow-lg shadow-black/30' 
                          : 'bg-white border border-gray-200'
                      }`}>
                        {salesStatuses.map(s => {
                          const count = sales.filter(o => s.key === 'all' || (o.status && o.status.toLowerCase() === s.key)).length;
                          if (s.key !== 'all' && count === 0) return null;
                          return (
                            <button
                              key={s.key}
                              className={`px-4 sm:px-6 py-2.5 rounded-lg font-semibold text-sm sm:text-base transition-all duration-200 ${
                                salesStatus === s.key 
                                  ? 'bg-red-600 text-white shadow-md' 
                                  : isDarkMode 
                                    ? 'bg-gray-700 text-gray-200 hover:bg-gray-600 border border-gray-600' 
                                    : 'bg-gray-50 text-gray-700 hover:bg-gray-100 border border-gray-200'
                              }`}
                              onClick={() => setSalesStatus(s.key)}
                            >
                              {s.label} ({count})
                            </button>
                          );
                        })}
                      </div>
                    </div>
                    {/* My Sales tab loading animation */}
                    {loadingSales ? (
                      <div className="flex flex-col items-center justify-center py-12">
                        <svg className="animate-spin h-10 w-10 text-red-400 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                        </svg>
                      </div>
                    ) : errorSales ? (
                      <div className="text-red-600">{errorSales}</div>
                    ) : sales.length === 0 ? (
                      <div className="flex flex-col items-center justify-center py-16 bg-white rounded-xl shadow-none border-none mx-auto max-w-lg mt-8">
                        {/* Shopping bags SVG icon */}
                        <svg width="80" height="80" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-4">
                          <rect x="14" y="20" width="24" height="28" rx="3" fill="#F87171" stroke="#111" strokeWidth="2"/>
                          <rect x="28" y="28" width="18" height="20" rx="2.5" fill="#FBBF24" stroke="#111" strokeWidth="2"/>
                          <path d="M20 20V16a8 8 0 0116 0v4" stroke="#111" strokeWidth="2"/>
                          <circle cx="22" cy="32" r="2" fill="#fff" stroke="#111" strokeWidth="1.5"/>
                          <circle cx="34" cy="32" r="2" fill="#fff" stroke="#111" strokeWidth="1.5"/>
                        </svg>
                        <div className="text-xl font-bold text-gray-900 mb-1 text-center">
                          No sales found.
                        </div>
                        <div className="text-gray-500 text-base text-center">
                          Your sales will be displayed here when available.
                        </div>
                      </div>
                    ) : (
                      <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">
                        {sales
                          .filter(o => salesStatus === 'all' || (o.status && o.status.toLowerCase().includes(salesStatus)))
                          .slice(0, salesToShow)
                          .map((o, idx) => (
                          <div key={o._id || o.order_id || idx} className={`rounded-2xl shadow overflow-hidden border flex flex-col transition-all duration-500 ${
                            isDarkMode 
                              ? 'bg-[#2a2a2a] shadow-2xl shadow-black/50 border-gray-700/50' 
                              : 'bg-white border-gray-100'
                          }`}>
                            <div className={`flex items-center justify-between px-4 py-2 transition-colors duration-300 ${
                              isDarkMode ? 'bg-gray-800/50' : 'bg-indigo-50'
                            }`}>
                              <span className={`font-semibold transition-colors duration-300 ${
                                isDarkMode ? 'text-gray-200' : 'text-gray-700'
                              }`}>#{o.order_id || o.order}</span>
                              <span className={`text-sm transition-colors duration-300 ${
                                isDarkMode ? 'text-gray-400' : 'text-gray-400'
                              }`}>{o.date ? new Date(o.date).toLocaleDateString('en-GB') : ''}</span>
                            </div>
                            <div className="flex flex-row items-start gap-4 px-4 py-4 flex-1">
                              {/* Left: Image and Status */}
                              <div className="flex flex-col items-start gap-2 min-w-[90px]">
                                <a
                                  href={o.product_id ? `/product/${o.product_id}` : '#'}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ display: 'block', width: '100%' }}
                                >
                                  <img
                                    src={getImageUrl(o.product_main_image) || 'https://placehold.co/80x80'}
                                    alt={o.product_title || o.product}
                                    className="w-20 h-20 rounded-lg object-cover mb-1"
                                    style={{ marginBottom: 4 }}
                                    onError={(e) => {
                                      e.target.src = 'https://placehold.co/80x80';
                                    }}
                                  />
                                </a>
                                {o.status && o.status !== 'all' && (
                                  <span className={`px-4 py-1 rounded-full text-sm font-semibold mt-1 transition-colors duration-300 ${
                                    o.status.toLowerCase().includes('onhold') ? (isDarkMode ? 'bg-yellow-900/50 text-yellow-200' : 'bg-yellow-100 text-yellow-800') :
                                    o.status.toLowerCase().includes('ready') ? (isDarkMode ? 'bg-pink-900/50 text-pink-200' : 'bg-pink-100 text-pink-700') :
                                    o.status.toLowerCase().includes('cancelled') ? (isDarkMode ? 'bg-red-900/50 text-red-200' : 'bg-red-100 text-red-700') :
                                    o.status.toLowerCase().includes('agent') ? (isDarkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-100 text-gray-700') :
                                    o.status.toLowerCase().includes('processing') ? (isDarkMode ? 'bg-blue-900/50 text-blue-200' : 'bg-blue-100 text-blue-700') :
                                    o.status.toLowerCase().includes('completed') ? (isDarkMode ? 'bg-green-900/50 text-green-200' : 'bg-green-100 text-green-700') :
                                    (isDarkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-200 text-gray-700')
                                  }`} style={{marginLeft: 0}}>{o.statusLabel || o.status}</span>
                                )}
                              </div>
                              {/* Right: Name and Price, fixed width and ellipsis */}
                              <div className="flex-1 flex flex-col items-start justify-start pl-2 pt-1 max-w-[180px]">
                                <a
                                  href={o.product_id ? `/product/${o.product_id}` : '#'}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={`font-bold text-lg mb-1 truncate w-full hover:text-red-600 transition-colors duration-300 ${
                                    isDarkMode ? 'text-white' : 'text-gray-900'
                                  }`}
                                  style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block'}}
                                  title={o.product_title || o.product}
                                >
                                  {o.product_title || o.product}
                                </a>
                                <div className="text-blue-700 font-bold text-lg mb-2">
                                  {o.salePrice ? (
                                    <span>${Number(o.salePrice).toFixed(2)}</span>
                                  ) : o.total ? (
                                    <span>${Number(o.total).toFixed(2)}</span>
                                  ) : o.price ? (
                                    <span>${Number(o.price).toFixed(2)}</span>
                                  ) : ''}
                                </div>
                              </div>
                            </div>
                            <div className={`flex items-center px-4 py-3 transition-colors duration-300 ${
                              isDarkMode ? 'bg-gray-800/50' : 'bg-indigo-50'
                            }`}>
                              <div className="flex items-center gap-2 flex-1">
                                {(() => {
                                  const profileUrl = o.buyerUsername ? `/profile/${o.buyerUsername}` : '#';
                                  return (
                                    <>
                                      <a
                                        href={profileUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ display: 'inline-block' }}
                                      >
                                        {o.buyer_avatar ? (
                                          <img src={o.buyer_avatar} alt={o.accountUsername || ''} className="w-8 h-8 rounded-full object-cover" />
                                        ) : (
                                          <div className={`w-8 h-8 rounded-full flex items-center justify-center text-lg font-bold transition-colors duration-300 ${
                                            isDarkMode ? 'bg-gray-700 text-gray-400' : 'bg-gray-200 text-gray-500'
                                          }`}>
                                            <span>{(o.accountUsername && o.accountUsername[0]) ? o.accountUsername[0].toUpperCase() : '?'}</span>
                                          </div>
                                        )}
                                      </a>
                                      <a
                                        href={profileUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`text-sm font-semibold hover:text-red-600 transition-colors duration-300 ${
                                          isDarkMode ? 'text-gray-300' : 'text-gray-700'
                                        }`}
                                        style={{ marginLeft: 4 }}
                                      >
                                        {o.buyerUsername || ''}
                                      </a>
                                    </>
                                  );
                                })()}
                              </div>
                              <button className="px-6 py-2 rounded-xl bg-red-600 text-white font-semibold hover:bg-red-700 transition ml-auto" onClick={() => setOrderModal(o)}>View Details</button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    {(!loadingSales && sales.filter(o => salesStatus === 'all' || (o.status && o.status.toLowerCase().includes(salesStatus))).length > salesToShow) && (
                      <div className="flex justify-center mt-6">
                        <button
                          className="px-6 py-2 rounded-full bg-red-600 text-white font-semibold hover:bg-red-700 transition"
                          onClick={() => setSalesToShow(salesToShow + 6)}
                        >
                          Load More
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {tab === 'purchases' && (
                <div>
                  <div className="mb-8">
                    <div className="text-2xl font-bold mb-4">My Purchases</div>
                    {/* Purchases Status Bar */}
                    <div className="mb-8">
                      <div className={`inline-flex flex-wrap gap-2 sm:gap-3 rounded-xl px-3 sm:px-4 py-2 items-center shadow-sm transition-all duration-300 ${
                        isDarkMode 
                          ? 'bg-gradient-to-br from-[#2a2a2a] via-[#1a1a1a] to-[#2a2a2a] border border-gray-700/50 shadow-lg shadow-black/30' 
                          : 'bg-white border border-gray-200'
                      }`}>
                        {purchaseStatuses.map(s => {
                          const count = purchases.filter(o => s.key === 'all' || (o.status && o.status.toLowerCase() === s.key)).length;
                          if (s.key !== 'all' && count === 0) return null;
                          return (
                            <button
                              key={s.key}
                              className={`px-4 sm:px-6 py-2.5 rounded-lg font-semibold text-sm sm:text-base transition-all duration-200 ${
                                purchaseStatus === s.key 
                                  ? 'bg-red-600 text-white shadow-md' 
                                  : isDarkMode 
                                    ? 'bg-gray-700 text-gray-200 hover:bg-gray-600 border border-gray-600' 
                                    : 'bg-gray-50 text-gray-700 hover:bg-gray-100 border border-gray-200'
                              }`}
                              onClick={() => setPurchaseStatus(s.key)}
                            >
                              {s.label} ({count})
                            </button>
                          );
                        })}
                      </div>
                    </div>
                    {/* My Purchases tab loading animation */}
                    {loadingPurchases ? (
                      <div className="flex flex-col items-center justify-center py-12">
                        <svg className="animate-spin h-10 w-10 text-red-400 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                        </svg>
                      </div>
                    ) : errorPurchases ? (
                      <div className="text-red-600">{errorPurchases}</div>
                    ) : purchases.length === 0 ? (
                      <div className="flex flex-col items-center justify-center py-16 bg-white rounded-xl shadow-none border-none mx-auto max-w-lg mt-8">
                        {/* Shopping bags SVG icon */}
                        <svg width="80" height="80" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-4">
                          <rect x="14" y="20" width="24" height="28" rx="3" fill="#F87171" stroke="#111" strokeWidth="2"/>
                          <rect x="28" y="28" width="18" height="20" rx="2.5" fill="#FBBF24" stroke="#111" strokeWidth="2"/>
                          <path d="M20 20V16a8 8 0 0116 0v4" stroke="#111" strokeWidth="2"/>
                          <circle cx="22" cy="32" r="2" fill="#fff" stroke="#111" strokeWidth="1.5"/>
                          <circle cx="34" cy="32" r="2" fill="#fff" stroke="#111" strokeWidth="1.5"/>
                        </svg>
                        <div className="text-xl font-bold text-gray-900 mb-1 text-center">
                          No purchases found.
                        </div>
                        <div className="text-gray-500 text-base text-center">
                          Your purchases will be displayed here when available.
                        </div>
                      </div>
                    ) : (
                      <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">
                        {purchases
                          .filter(s => purchaseStatus === 'all' || (s.status && s.status.toLowerCase().includes(purchaseStatus)))
                          .slice(0, purchasesToShow)
                          .map((s, idx) => (
                          <div key={s._id || s.order_id || idx} className={`rounded-2xl shadow overflow-hidden border flex flex-col transition-all duration-500 ${
                            isDarkMode 
                              ? 'bg-[#2a2a2a] shadow-2xl shadow-black/50 border-gray-700/50' 
                              : 'bg-white border-gray-100'
                          }`}>
                            <div className={`flex items-center justify-between px-4 py-2 transition-colors duration-300 ${
                              isDarkMode ? 'bg-gray-800/50' : 'bg-indigo-50'
                            }`}>
                              <span className={`font-semibold transition-colors duration-300 ${
                                isDarkMode ? 'text-gray-200' : 'text-gray-700'
                              }`}>#{s.order_id || s.order}</span>
                              <span className={`text-sm transition-colors duration-300 ${
                                isDarkMode ? 'text-gray-400' : 'text-gray-400'
                              }`}>{s.date ? new Date(s.date).toLocaleDateString('en-GB') : (s.date ? s.date.split('-').reverse().join('/') : '')}</span>
                            </div>
                            <div className="flex flex-row items-start gap-4 px-4 py-4 flex-1">
                              {/* Left: Image and Status */}
                              <div className="flex flex-col items-start gap-2 min-w-[90px]">
                                <a
                                  href={s.product_id ? `/product/${s.product_id}` : '#'}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ display: 'block', width: '100%' }}
                                >
                                  <img
                                    src={getImageUrl(s.product_main_image) || 'https://placehold.co/80x80'}
                                    alt={s.product_title || s.product}
                                    className="w-20 h-20 rounded-lg object-cover mb-1"
                                    style={{ marginBottom: 4 }}
                                    onError={(e) => {
                                      e.target.src = 'https://placehold.co/80x80';
                                    }}
                                  />
                                </a>
                                {s.status && s.status !== 'all' && (
                                  <span className={`px-4 py-1 rounded-full text-sm font-semibold mt-1 transition-colors duration-300 ${
                                    s.status.toLowerCase().includes('onhold') ? (isDarkMode ? 'bg-yellow-900/50 text-yellow-200' : 'bg-yellow-100 text-yellow-800') :
                                    s.status.toLowerCase().includes('completed') ? (isDarkMode ? 'bg-green-900/50 text-green-200' : 'bg-green-100 text-green-700') :
                                    s.status.toLowerCase().includes('wrong') ? (isDarkMode ? 'bg-red-900/50 text-red-200' : 'bg-red-100 text-red-700') :
                                    (isDarkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-200 text-gray-700')
                                  }`} style={{marginLeft: 0}}>{s.statusLabel || s.status}</span>
                                )}
                              </div>
                              {/* Right: Name and Price, fixed width and ellipsis */}
                              <div className="flex-1 flex flex-col items-start justify-start pl-2 pt-1 max-w-[180px]">
                                <a
                                  href={s.product_id ? `/product/${s.product_id}` : '#'}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={`font-bold text-lg mb-1 truncate w-full hover:text-red-600 transition-colors duration-300 ${
                                    isDarkMode ? 'text-white' : 'text-gray-900'
                                  }`}
                                  style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block'}}
                                  title={s.product_title || s.product}
                                >
                                  {s.product_title || s.product}
                                </a>
                                <div className="text-blue-700 font-bold text-lg mb-2">
                                  {s.salePrice ? (
                                    <span>${Number(s.salePrice).toFixed(2)}</span>
                                  ) : s.total ? (
                                    <span>${Number(s.total).toFixed(2)}</span>
                                  ) : s.price ? (
                                    <span>${Number(s.price).toFixed(2)}</span>
                                  ) : ''}
                                </div>
                              </div>
                            </div>
                            <div className={`flex items-center px-4 py-3 transition-colors duration-300 ${
                              isDarkMode ? 'bg-gray-800/50' : 'bg-indigo-50'
                            }`}>
                              <div className="flex items-center gap-2 flex-1">
                                {(() => {
                                  const profileUrl = s.seller_name ? `/profile/${s.seller_name}` : '#';
                                  return (
                                    <>
                                      <a
                                        href={profileUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ display: 'inline-block' }}
                                      >
                                        {s.seller_avatar || s.sellerAvatar ? (
                                          <img src={s.seller_avatar || s.sellerAvatar} alt={s.seller_name || s.seller || ''} className="w-8 h-8 rounded-full object-cover" />
                                        ) : (
                                          <div className={`w-8 h-8 rounded-full flex items-center justify-center text-lg font-bold transition-colors duration-300 ${
                                            isDarkMode ? 'bg-gray-700 text-gray-400' : 'bg-gray-200 text-gray-500'
                                          }`}>
                                            <span>{(s.seller_name && s.seller_name[0]) ? s.seller_name[0].toUpperCase() : (s.seller && s.seller[0] ? s.seller[0].toUpperCase() : '?')}</span>
                                          </div>
                                        )}
                                      </a>
                                      <a
                                        href={profileUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`text-sm font-semibold hover:text-red-600 transition-colors duration-300 ${
                                          isDarkMode ? 'text-gray-300' : 'text-gray-700'
                                        }`}
                                        style={{ marginLeft: 4 }}
                                      >
                                        {s.seller_name || ''}
                                      </a>
                                    </>
                                  );
                                })()}
                              </div>
                              <button className="px-6 py-2 rounded-xl bg-red-600 text-white font-semibold hover:bg-red-700 transition ml-auto">View Details</button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    {(!loadingPurchases && purchases.filter(s => purchaseStatus === 'all' || (s.status && s.status.toLowerCase().includes(purchaseStatus))).length > purchasesToShow) && (
                      <div className="flex justify-center mt-6">
                        <button
                          className="px-6 py-2 rounded-full bg-red-600 text-white font-semibold hover:bg-red-700 transition"
                          onClick={() => setPurchasesToShow(purchasesToShow + 6)}
                        >
                          Load More
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Order Details Modal for My Sales tab */}
      {orderModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className={`rounded-2xl shadow-xl p-8 w-full max-w-3xl relative transition-all duration-500 ${
            isDarkMode 
              ? 'bg-[#2a2a2a] shadow-2xl shadow-black/50 border border-gray-700/50' 
              : 'bg-white'
          }`}>
            <button className={`absolute top-2 right-2 text-2xl transition-colors duration-300 ${
              isDarkMode ? 'text-gray-400 hover:text-red-400' : 'text-gray-400 hover:text-red-500'
            }`} onClick={() => setOrderModal(null)}>&times;</button>
            <h3 className={`text-2xl font-bold mb-4 flex items-center gap-2 transition-colors duration-300 ${
              isDarkMode ? 'text-white' : 'text-black'
            }`}>
              <span className={`inline-block rounded-full p-2 transition-colors duration-300 ${
                isDarkMode ? 'bg-red-900/50 text-red-400' : 'bg-red-100 text-red-600'
              }`}><svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M6 6h15l-1.5 9h-13z"/><circle cx="9" cy="21" r="1"/><circle cx="19" cy="21" r="1"/></svg></span>
              Order #{orderModal.order_id}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-6">
              <div>
                <div className={`mb-2 transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-black'
                }`}><b>Order Number:</b> #{orderModal.order_id}</div>
                <div className={`mb-2 transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-black'
                }`}><b>Order Date:</b> {orderModal.date ? new Date(orderModal.date).toLocaleString('en-GB') : ''}</div>
                <div className={`mb-2 transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-black'
                }`}><b>Status:</b> <span className="font-semibold text-green-500">{orderModal.status}</span></div>
              </div>
              <div className={`rounded-xl p-4 flex flex-col gap-2 transition-all duration-300 ${
                isDarkMode ? 'bg-gray-800/50 border border-gray-700/50' : 'bg-gray-50'
              }`}>
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-3">
                    {orderModal.buyer_avatar ? (
                      <img src={orderModal.buyer_avatar} alt={orderModal.buyerUsername || ''} className="w-10 h-10 rounded-full object-cover" />
                    ) : (
                      <div className={`w-10 h-10 rounded-full flex items-center justify-center text-lg font-bold transition-colors duration-300 ${
                        isDarkMode ? 'bg-gray-700 text-gray-400' : 'bg-gray-200 text-gray-500'
                      }`}>
                        <span>{(orderModal.buyerUsername && orderModal.buyerUsername[0]) ? orderModal.buyerUsername[0].toUpperCase() : '?'}</span>
                      </div>
                    )}
                    <div>
                      <div className={`font-semibold transition-colors duration-300 ${
                        isDarkMode ? 'text-gray-300' : 'text-black'
                      }`}>Buyer:</div>
                      <div className={`transition-colors duration-300 ${
                        isDarkMode ? 'text-white' : 'text-black'
                      }`}>{orderModal.buyerUsername || ''}</div>
                    </div>
                  </div>
                  <button className={`border px-4 py-2 rounded-lg font-semibold transition-colors duration-300 ${
                    isDarkMode 
                      ? 'border-red-500 text-red-400 hover:bg-red-900/50' 
                      : 'border-red-500 text-red-500 hover:bg-red-50'
                  }`}>Contact Buyer</button>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-6">
              <div className="flex gap-4 items-center">
                <img
                  src={getImageUrl(orderModal.product_main_image) || 'https://placehold.co/80x80'}
                  alt={orderModal.product_title}
                  className="w-24 h-24 rounded-lg object-cover"
                  onError={(e) => {
                    e.target.src = 'https://placehold.co/80x80';
                  }}
                />
                <div>
                  <div className={`font-bold text-lg mb-1 transition-colors duration-300 ${
                    isDarkMode ? 'text-white' : 'text-black'
                  }`}>{orderModal.product_title}</div>
                  <div className={`text-sm mb-1 transition-colors duration-300 ${
                    isDarkMode ? 'text-gray-400' : 'text-gray-500'
                  }`}>Seller: <span className={`font-semibold transition-colors duration-300 ${
                    isDarkMode ? 'text-gray-300' : 'text-black'
                  }`}>{orderModal.seller_name}</span></div>
                  <div className="text-blue-500 font-bold text-lg">${orderModal.total ? orderModal.total.toFixed(2) : ''}</div>
                </div>
              </div>
              <div className={`rounded-xl p-4 flex flex-col gap-2 transition-all duration-300 ${
                isDarkMode ? 'bg-gray-800/50 border border-gray-700/50' : 'bg-gray-50'
              }`}>
                <div className={`transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-black'
                }`}><b>Order Notes:</b> <span className={`transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-400' : 'text-gray-600'
                }`}>{orderModal.order_notes || '—'}</span></div>
                <div className={`transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-black'
                }`}><b>Subtotal:</b> USD ${orderModal.total ? orderModal.total.toFixed(2) : ''}</div>
                <div className={`transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-black'
                }`}><b>Total:</b> USD ${orderModal.total ? orderModal.total.toFixed(2) : ''}</div>
                <div className={`transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-black'
                }`}><b>Payment Method:</b> <span className={`transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-400' : 'text-gray-600'
                }`}>{orderModal.payment_method || '—'}</span></div>
              </div>
            </div>
            <div className="flex justify-end">
              <button className={`px-6 py-2 rounded-xl font-semibold transition-colors duration-300 ${
                isDarkMode 
                  ? 'bg-gray-700 text-gray-200 hover:bg-gray-600' 
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`} onClick={() => setOrderModal(null)}>Close</button>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
}